// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class SignedDashboard {
  readonly name: string;
  readonly url: string;

  constructor(data: { [key: string]: any } = {}) {
    this.name = data.name === undefined ? '' : data.name;
    this.url = data.url === undefined ? '' : data.url;
  }

  static zero(): SignedDashboard {
    const zeroValues: ExcludeMethodsDeep<SignedDashboard> = {
      name: '',
      url: '',
    };
    return new SignedDashboard(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type SignedDashboardWireFormat = {
  name: string;
  url: string;
};

type NewSignedDashboardProps = PartialDeep<SignedDashboard, { recurseIntoArrays: true }>;
export const NewSignedDashboard: (props: NewSignedDashboardProps) => SignedDashboard = (props) =>
  new SignedDashboard(props);

type NewSignedDashboardFromWireFormatProps = PartialDeep<
  SignedDashboardWireFormat,
  { recurseIntoArrays: true }
>;
export const NewSignedDashboardFromWireFormat: (
  props: NewSignedDashboardFromWireFormatProps,
) => SignedDashboard = (props) => new SignedDashboard(props);
